import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const EnglishPage = lazy(() => import('../pages/en/page'));
const ScoresPage = lazy(() => import('../pages/scores/page'));
const PhilosophyPage = lazy(() => import('../pages/philosophy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/en',
    element: <EnglishPage />,
  },
  {
    path: '/scores',
    element: <ScoresPage />,
  },
  {
    path: '/philosophy',
    element: <PhilosophyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;